(function () {
    'use strict';

    angular
        .module('rms.common')
        .factory('filterBarAdapter', filterBarAdapter);

    function filterBarAdapter(lodash) {
        return function(query) {
            const results = {};

            results.filter = query.filters.map((filter) => {
                return {
                    field: filter.name,
                    operator: filter.operator,
                    value: filter.value
                };
            });

            if (!lodash.isEmpty(query.search)) {
                results.filter.push({
                    field: 'filter_search_text',
                    operator: 'contains',
                    value: query.search
                });
            }

            if (!lodash.isEmpty(query.order_by)) {
                results.sort = [query.order_by];
            }

            return results;
        };
    }
})();